import React from 'react';
import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { Timeline, TimelineItem, TimelineSeparator, TimelineConnector, TimelineContent, TimelineOppositeContent, TimelineDot } from '@mui/lab';
import dayjs from 'dayjs';

const MeterReadingTimeline = ({ meterReadings }) => {
  return (
    <Box>
      <Timeline>
        {meterReadings.map((reading, index) => {
          return (
            <TimelineItem key={reading.id}>
              {/* Sol Tarafta Sayaç Okuma Tarihi ve Gün Farkı */}
              <TimelineOppositeContent color="text.secondary">
                <Typography variant="body2">
                  {dayjs(reading.readingTime).format('DD/MM/YYYY')}
                </Typography>
                {reading.previousReadingDayDiff != null && (
                  <Typography variant="body2" color="text.secondary">
                    {`${reading.previousReadingDayDiff} Gün Aralık`}
                  </Typography>
                )}
                {reading.meterReadingType == 'V' && (
                  <Typography variant="body2" color="text.secondary">
                    {`Faturaya orantılanmış sanal okuma`}
                  </Typography>
                )}
              </TimelineOppositeContent>

              <TimelineSeparator>
                <TimelineDot />
                {index < meterReadings.length - 1 && <TimelineConnector />}
              </TimelineSeparator>

              {/* Sağ Tarafta Endeks Değerleri Tablo Formatında */}
              <TimelineContent>
                <Typography variant="h6">
                  {reading.readingReason === 'I' && 'Fatura Tarihi için orantılanmış okuma'}
                  {reading.readingReason === 'A' && 'Gerçek Okuma'}
                </Typography>
                <TableContainer component={Paper} sx={{ mt: 2 }}>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell><strong>Endeks Tipi</strong></TableCell>
                        <TableCell><strong>Endeks Değeri</strong></TableCell>
                        <TableCell><strong>Bir Önceki Okuma Farkı</strong></TableCell>
                        <TableCell><strong>Günlük Tüketim</strong></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {reading.meterReadingDetails.map((detail) => (
                        <TableRow key={detail.indexTypeDto.indexType}>
                          <TableCell>{detail.indexTypeDto.indexName}</TableCell>
                          <TableCell>{detail.index}</TableCell>
                          <TableCell style={{ color: detail.indexDiff > 0 ? 'green' : detail.indexDiff < 0 ? 'red' : 'black' }}>
                            {detail.indexDiff !== null ? (
                              `${detail.indexDiff > 0 ? '+' : ''}${detail.indexDiff} (${detail.indexDiff > 0 ? 'Artış' : detail.indexDiff < 0 ? 'Azalış' : 'Değişiklik Yok'})`
                            ) : (
                              '-'
                            )}
                          </TableCell>
                          <TableCell>
                            {detail && detail.dailyConsumption != null ? detail.dailyConsumption.toFixed(2) : '-'}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </TimelineContent>
            </TimelineItem>
          );
        })}
      </Timeline>
    </Box>
  );
};

export default MeterReadingTimeline;
